// extracted by mini-css-extract-plugin
export default {"page":"gigVW","title":"wEEmh","tabs":"PfQWw","inner":"NQOun","action":"tfkgi"};